// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClaimList_info-message__bXZ9V a {
  width: 100%;
  font-weight: 500;
  font-size: 16px;
}
.ClaimList_info-message__bXZ9V a:hover {
  text-decoration: none;
}

.ClaimList_claim-button__B8A8u {
  width: 185px;
}

.ClaimList_items__hw9se {
  flex: 2 1;
  margin-top: 20px;
}

.ClaimList_item__FxLXR {
  position: relative;
}
.ClaimList_item__FxLXR:not(:last-child) {
  margin-bottom: 12px;
}

.ClaimList_item-content__aCbWi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ClaimList_item-content__aCbWi p {
  max-width: calc(100% - 150px);
}
.ClaimList_item-content__aCbWi span {
  font-weight: 300;
}

.ClaimList_empty-list-message__wfmNj {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  color: #00007a;
}

@media screen and (max-width: 600px) {
  .ClaimList_info-message__bXZ9V button {
    height: 35px;
  }
  .ClaimList_claim-button__B8A8u {
    width: 100%;
  }
  .ClaimList_items__hw9se {
    margin-top: 28px;
  }
}
@media screen and (max-width: 900px) {
  .ClaimList_item-content__aCbWi p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Claims/ClaimList/ClaimList.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAIE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAGJ;AADI;EACE,qBAAA;AAGN;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAEE;EACE,6BAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cChDS;AD8CX;;AAKA;EAEI;IACE,YAAA;EAHJ;EAOA;IACE,WAAA;EALF;EAQA;IACE,gBAAA;EANF;AACF;AASA;EAEI;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;EARJ;AACF","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n.info-message {\n  a {\n    width: 100%;\n    font-weight: 500;\n    font-size: 16px;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.claim-button {\n  width: 185px;\n}\n\n.items {\n  flex: 2;\n  margin-top: 20px;\n}\n\n.item {\n  position: relative;\n\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n}\n\n.item-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  p {\n    max-width: calc(100% - 150px);\n  }\n\n  span{\n    font-weight: 300;\n  }\n}\n\n.empty-list-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 36px;\n  text-align: center;\n  color: colors.$primary8;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .info-message {\n    button {\n      height: 35px;\n    }\n  }\n\n  .claim-button {\n    width: 100%;\n  }\n\n  .items {\n    margin-top: 28px;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-md) {\n  .item-content {\n    p {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"info-message": `ClaimList_info-message__bXZ9V`,
	"claim-button": `ClaimList_claim-button__B8A8u`,
	"items": `ClaimList_items__hw9se`,
	"item": `ClaimList_item__FxLXR`,
	"item-content": `ClaimList_item-content__aCbWi`,
	"empty-list-message": `ClaimList_empty-list-message__wfmNj`
};
export default ___CSS_LOADER_EXPORT___;
